type ContactSeoHour = {
  dayOfWeek: string[];
  opens: string;
  closes: string;
};

type ContactSchedule = {
  telephoneDisplay: string;
  seoTelephone: string;
  serviceHours: string[];
  seoHoursAvailable?: ContactSeoHour[];
};

type ContactConfig = {
  callUsSchedules: ContactSchedule[];
};

const CONTACT_CONFIG_BY_STORE_VIEW_CODE: Record<string, ContactConfig> = {
  us: {
    callUsSchedules: [
      // {
      //   telephoneDisplay: '1-888-553-8810',
      //   seoTelephone: '+1-888-553-8810',
      //   serviceHours: ['Monday - Friday 9:00 am - 5:00 pm PT'],
      //   seoHoursAvailable: [
      //     { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '17:00' },
      //   ],
      // },
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Sunday - Thursday 5:00 pm - 1:00 am PT'],
        seoHoursAvailable: [
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '17:00', closes: '01:00' },
        ],
      },
    ],
  },
  uk: {
    callUsSchedules: [
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Monday - Friday 9:00 am - 5:00 pm GMT', 'Sunday - Thursday 8:00 am - 12:00 pm GMT'],
        seoHoursAvailable: [
          { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '17:00' },
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '08:00', closes: '12:00' },
        ],
      },
    ],
  },
  ca: {
    callUsSchedules: [
      // {
      //   telephoneDisplay: '1-888-553-8810',
      //   seoTelephone: '+1-888-553-8810',
      //   serviceHours: ['Monday - Friday 9:00 am - 5:00 pm PT'],
      //   seoHoursAvailable: [
      //     { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '17:00' },
      //   ],
      // },
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Sunday - Thursday 5:00 pm - 1:00 am PT'],
        seoHoursAvailable: [
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '17:00', closes: '01:00' },
        ],
      },
    ],
  },
  au: {
    callUsSchedules: [
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Monday - Friday 9:00 am - 5:00 pm AEST', 'Sunday - Thursday 10:00 am- 6:00 pm AEST'],
        seoHoursAvailable: [
          { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '17:00' },
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '10:00', closes: '18:00' },
        ],
      },
    ],
  },
  ie: {
    callUsSchedules: [
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Monday - Friday 9:00 am - 5:00 pm GMT', 'Sunday - Thursday 8:00 am - 12:00 pm GMT'],
        seoHoursAvailable: [
          { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '17:00' },
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '08:00', closes: '12:00' },
        ],
      },
    ],
  },
  nz: {
    callUsSchedules: [
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Monday - Friday 9:00 am - 5:30 pm NZST', 'Sunday - Thursday 12:00 pm - 5:00 pm NZST'],
        seoHoursAvailable: [
          { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '17:30' },
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '12:00', closes: '17:00' },
        ],
      },
    ],
  },
  de_en: {
    callUsSchedules: [
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Monday - Friday 9:00 am - 6:00 pm CET', 'Sunday - Thursday 8:00 am - 12:00 pm CET'],
        seoHoursAvailable: [
          { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '18:00' },
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '08:00', closes: '12:00' },
        ],
      },
    ],
  },
  sg: {
    callUsSchedules: [
      {
        telephoneDisplay: '1-323-880-1668',
        seoTelephone: '+1-323-880-1668',
        serviceHours: ['Monday - Friday 9:00 am - 6:00 pm SGT', 'Sunday - Thursday 8:00 am - 4:00 pm SGT'],
        seoHoursAvailable: [
          { dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '18:00' },
          { dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '08:00', closes: '16:00' },
        ],
      },
    ],
  },
};

const DEFAULT_CONTACT_CONFIG: ContactConfig = {
  callUsSchedules: [],
};

export const getStoreContactConfig = (storeViewCode = process.env.NEXT_PUBLIC_STORE_VIEW_CODE): ContactConfig => {
  const normalizedStoreViewCode = (storeViewCode || '').toLowerCase();
  return CONTACT_CONFIG_BY_STORE_VIEW_CODE[normalizedStoreViewCode] || DEFAULT_CONTACT_CONFIG;
};

export const getCurrentStoreContactConfig = (): ContactConfig => getStoreContactConfig();
